const OrderProductPaymentManagementStyle = () => ({
    room: {
        border: '1px solid',
        borderRadius: '13px',
    },
    titleDetail: {
        paddingTop: '15px',
    },
    customTable: {
        maxHeight: '400px',
    },
    invoiceNumber: {
        textAlign: 'end',
        paddingRight: '25px',
    },
    totalPrice: {
        paddingLeft: '25px',
    },
});

export default OrderProductPaymentManagementStyle;
